<app-toast />
<router-outlet />

